import { colorFromUserId } from "@hireroo/app-helper/color";
import { useDevicesContext } from "@hireroo/app-helper/hooks";
import { RemoteUser, useAgoraRemoteTracks } from "@hireroo/app-helper/livecoding/agora";
import { RemoteInterviewParticipants } from "@hireroo/app-store/widget/shared/RemoteInterviewParticipants";
import { Widget } from "@hireroo/presentation";
import React from "react";

export type GenerateLiveCodingVideoViewPropsArgs = {
  user: RemoteUser;
  isLocal: boolean;
};

export const useGenerateProps = (props: GenerateLiveCodingVideoViewPropsArgs): Widget.LiveCodingVideoViewProps => {
  const { isAudioEnabled: isAudioEnabledLocal, isVideoEnabled: isVideoEnabledLocal, videoTrack: localVideoTrack } = useDevicesContext();
  const { videoTrack: remoteVideoTrack } = useAgoraRemoteTracks({ remoteUser: props.user });

  const participants = RemoteInterviewParticipants.useParticipants();
  const participantInfo = React.useMemo(() => {
    return participants.find(participant => participant.id === props.user.uid.toString());
  }, [participants, props.user.uid]);
  const userInfoMap = RemoteInterviewParticipants.useUserInfoMap();
  const userInfo = userInfoMap.get(props.user.uid.toString());

  return {
    id: props.isLocal ? "local" : props.user.uid.toString(),
    avatar: {
      sx: { bgcolor: colorFromUserId(props.user.uid.toString()) },
      src: userInfo?.employee?.photoUrl || "",
      alt: participantInfo?.displayName || props.user.uid.toString(),
    },
    title: props.isLocal ? "あなた" : participantInfo?.displayName ?? props.user.uid.toString(),
    videoTrack: {
      track: props.isLocal ? localVideoTrack : remoteVideoTrack,
      isFrontFacing: true,
      isPortrait: false,
    },
    isAudioEnabled: props.isLocal ? isAudioEnabledLocal : props.user.hasAudio,
    isVideoEnabled: props.isLocal ? isVideoEnabledLocal : props.user.hasVideo,
  };
};
